<template>
  <div class="main-panel">
    <slot></slot>
  </div>
</template>

<script src="./MainPanel.js"></script>

<style lang="scss" src="./MainPanel.scss"></style>
